"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var scroll_manager_1 = __importDefault(require("~/util/scroll_manager"));
var DISPLAY_HEIGHT_RATE = 0.5;
var HIDDEN_CLASS_NAME = 'st-FixedFooter_EstimatePromotion-hidden';
var FixedFooterBalloonController = /** @class */ (function (_super) {
    __extends(FixedFooterBalloonController, _super);
    function FixedFooterBalloonController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            scroll_manager_1.default.onOverBorder(DISPLAY_HEIGHT_RATE, function () {
                (0, jquery_1.default)(_this.element).removeClass(HIDDEN_CLASS_NAME);
            });
        };
        return _this;
    }
    return FixedFooterBalloonController;
}(stimulus_1.Controller));
exports.default = FixedFooterBalloonController;
